export default __webpack_public_path__ + "locales/ro/HotkeysPanel.json?hash=89d7c261a0a3a22f2dfe69e5dc44a089";